import { createGlobalState } from '@vueuse/core'
import { FEATURE_IDS } from 'src/tpbp-core/feature-flag/featureFlags.const'
import { hasFeature } from 'src/tpbp-core/feature-flag/featureFlags.utils'
import { ref } from 'vue'
import type { AppContext } from './global-types'
import type { ApiUserRole } from './services/json-api/json-api.types'
import { API_USER_ROLES } from './services/json-api/json-api.types'

function computeLogKey(id: string, key: string) {
  return `session_id: ${id} - ${key}`
}

export const globalStoreForLogging = createGlobalState(() => {
  const id = Math.random().toString(36).slice(2, 11) + Date.now().toString(36)
  const endRaised = ref(0)
  const numberOfPossibileEnd = 3

  function startLog(key: string) {
    if (!hasFeature(FEATURE_IDS.debugTime)) return

    // eslint-disable-next-line no-console
    console.time(computeLogKey(id, key))
  }

  function endLog(key: string) {
    if (!hasFeature(FEATURE_IDS.debugTime)) return

    // eslint-disable-next-line no-console
    console.timeEnd(computeLogKey(id, key))
  }

  function startGlobalLog() {
    if (!hasFeature(FEATURE_IDS.debugTime)) return

    endRaised.value = 0
    // eslint-disable-next-line no-console
    console.time(computeLogKey(id, 'totalDuration'))
  }

  function endGlobalLog() {
    if (!hasFeature(FEATURE_IDS.debugTime)) return

    endRaised.value = endRaised.value + 1
    if (endRaised.value === numberOfPossibileEnd) {
      // eslint-disable-next-line no-console
      console.timeEnd(computeLogKey(id, 'totalDuration'))
    }
  }

  return {
    startLog,
    endLog,
    startGlobalLog,
    endGlobalLog,
  }
})

export function getUserRole(
  advisingReportAuthToken: string | null | undefined,
  storedUserRole: string | null | undefined,
): ApiUserRole {
  if (advisingReportAuthToken)
    return API_USER_ROLES.ADVISING_REPORT_PDF_GENERATOR

  return storedUserRole === API_USER_ROLES.ADVISOR
    ? API_USER_ROLES.ADVISOR
    : API_USER_ROLES.SELF_CARE
}

export function getApiUrl(context: AppContext, userRole: ApiUserRole): string {
  const isAdvisingReportPdfGenerator =
    userRole === API_USER_ROLES.ADVISING_REPORT_PDF_GENERATOR

  if (
    isAdvisingReportPdfGenerator &&
    (context.apiUrlAdvisingReport ?? '') !== ''
  )
    return context.apiUrlAdvisingReport

  return userRole === API_USER_ROLES.ADVISOR
    ? context.apiUrl
    : context.apiUrlSelfcare
}
